<template>
    <active-engaged-chart
            class="ma-0 pt-5"
            :data="activeEngagedData"
            height="100%"
            width="100%"
            v-if="displayChart"
    ></active-engaged-chart>
</template>

<script>

    import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';
    import ActiveEngagedChart from "../../Health/components/ActiveEngagedChart";

    export default {

        components: {
            ActiveEngagedChart
        },

        props: {
            name: {
                type: String,
                required: true
            }
        },

        mounted() {
            this.loadData();
        },

        computed: {
            // Root store
            ...mapState([
                'activeEngaged',
            ]),

            displayChart() {
                return this.activeEngaged.all.count > 0;
            },

            activeEngagedData() {

                return [
                    {
                        name: 'Active panelists',
                        percent: this.activeEngaged.active.count,
                        name2: 'Engaged panelists',
                        percent2: this.activeEngaged.engaged.count
                    },
                    {
                        name: 'Non active panelists',
                        percent: this.activeEngaged.all.count - this.activeEngaged.active.count,
                        name2: 'Non engaged panelists',
                        percent2: this.activeEngaged.all.count - this.activeEngaged.engaged.count,
                    }
                ]
            },
        },

        methods: {

            // Root store
            ...mapActions([
                'getActiveEngagedTopline',
            ]),

            loadData(force = false) {

                this.$emit('loading-started');

                this.getActiveEngagedTopline(force)
                    .then(() => {

                        if (!this.displayChart) {
                            this.$emit('insufficient-data', {
                                title: 'No data available',
                            });
                        } else {
                            this.$emit('sufficient-data', true);
                        }

                        this.$emit('loading-ended');
                    })
                    .catch(error => {
                        Bus.$emit('flash-message', {type: 'error', message: 'Active / engaged statistics failed to load!'});
                        this.$emit('loading-ended');
                    });
            }
        },

        created() {
            this.$emit('settings', {title: 'Active vs. Engaged', info: 'Panel health', configs: []});

            Bus.$on('refresh-widget-' + this.name, () => {
                this.loadData(true);
            });
        },
    }
</script>

<style scoped>
    .chart {
        width: 100%;
        height: 325px;
    }
</style>
